// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es6.math.sign.js
// module id = 1250
// module chunks = 168707334958949